import { ConnectionsState } from '../../connections/store/connections.state';
import { UserState } from '../../user/store/user.state';
import { userReducer } from '../../user/store/user.reducer';
import { connectionsReducer } from '../../connections/store/connections.reducer';
import { invitationsReducer } from '../../invitations/store/invitations.reducer';
import { ActionReducerMap } from '@ngrx/store';
import { PostsState } from '../../posts/store/posts.state';
import { postsReducer } from '../../posts/store/posts.reducer';
import { TimerState } from './timer.state';
import { timerReducer } from './timer.reducer';
import { InvitationsState } from '../../invitations/store/invitations.state';
import { MessageState } from '../../messages/store/messages.state';
import { MessagesReducer } from '../../messages/store/messages.reducer';
import { TagsState } from '../../tags/store/tags.state';
import { tagsReducer } from '../../tags/store/tags.reducer';
import { CommunitiesState } from '../../communities/store/communities.state';
import { communitiesReducer } from '../../communities/store/communities.reducer';
import { ShoppingCartState } from '../../shoppingCart/store/shoppingCart.state';
import { shoppingCartReducer } from '../../shoppingCart/store/shoppingCart.reducer';
import { CheckoutState } from '../../checkout/store/checkout.state';
import { checkoutReducer } from '../../checkout/store/checkout.reducer';
import { CourseState } from '../../courses/store/course.state';
import { courseReducer } from '../../courses/store/course.reducer';
import { OrderState } from '../../order/store/order.state';
import { orderReducer } from '../../order/store/order.reducer';

export interface AppState {
  user: UserState;
  connections: ConnectionsState;
  posts: PostsState;
  timer: TimerState;
  invitations: InvitationsState;
  messages: MessageState;
  tags: TagsState;
  communities: CommunitiesState;
  shoppingCart: ShoppingCartState;
  checkout: CheckoutState,
  course: CourseState,
  order: OrderState
}

export const appInitialState:AppState = {
  user: {} as UserState,
  connections: {} as ConnectionsState,
  posts: {} as PostsState,
  timer: {} as TimerState,
  invitations: {} as InvitationsState,
  messages: {} as MessageState,
  tags: {} as TagsState,
  communities: {} as CommunitiesState,
  shoppingCart: {} as ShoppingCartState,
  checkout: {} as CheckoutState,
  course: {} as CourseState,
  order: {} as OrderState,
}

export const reducers: ActionReducerMap<AppState> = {
  user: userReducer,
  connections: connectionsReducer,
  posts: postsReducer,
  timer: timerReducer,
  invitations: invitationsReducer,  
  messages: MessagesReducer,
  tags: tagsReducer,
  communities: communitiesReducer,
  shoppingCart: shoppingCartReducer,
  checkout: checkoutReducer,
  course: courseReducer,
  order: orderReducer
};  
